<template>
  <div class="FilterBar-select">
      <label class="FilterBar-selectLabel" :for="id">{{label}}</label>
      <select 
        class="FilterBar-selectControl" 
        :name="name" 
        :id="id"
        :value="modelValue" 
        @change="$emit('update:modelValue', $event.target.value)">
          <option v-for="(option) in options" :value="option.value" :key="option.value">
            {{option.label || option.value}}
          </option>
      </select>
  </div>
</template>

<script>
import uniqueId from 'lodash/uniqueId';

export default {
  emits: ['update:modelValue'],

  data () {
    return {
      id: uniqueId('select-'),
      selected: []
    }
  }, 

  props: {
    name: String,
    value: String,
    modelValue: [Number, String],
    label: String,
    options: Array
  }
}
</script>

